import { render } from "./DataTime.vue?vue&type=template&id=f6f9b69a"
import script from "./DataTime.vue?vue&type=script&lang=js"
export * from "./DataTime.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__